import CustomIcon from './custom-icon';

/** Golf: a flag on the green. lucide has no golf icon. */
const GolfIcon = (props) => (
  <CustomIcon {...props}>
    <path d="M12 17V3l7 3.5-7 3.5" />
    <path d="M8.5 14.3C5.8 14.9 4 16.1 4 17.5 4 19.4 7.6 21 12 21s8-1.6 8-3.5c0-1.4-1.8-2.6-4.5-3.2" />
  </CustomIcon>
);

export default GolfIcon;
